import type { RootState } from '@/_store/store';

export const selectMemberSelected = (state: RootState) =>
  state.members.memberSelected;
export const selectMembers = (state: RootState) => state.members.payload;
